import MatchPlayScores from './match-play-scores'

export default MatchPlayScores
